<div class="modal-content">
  <div class="modal-body text-center">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <jhi-alert></jhi-alert>
    <p class="lead pt-4" [innerHTML]="message"></p>
  </div>

  <div class="modal-footer justify-content-center align-items-baseline">
    <div
      #paymentMethodExtra
      *ngIf="userTypology === listUserTypology.CB
    || (userTypology === listUserTypology.SEPA && !hasSepaAlias)
    || userTypology === listUserTypology.INIT_TRANSFERT_IMMEDIATE
    || (userTypology === listUserTypology.INIT_TRANSFERT_DEFERRED && params.idBasketOrder)
"
    >
      <span class="spinner-border text-main"></span>
    </div>
    <jhi-bary-button
      *ngIf="(userTypology === listUserTypology.SEPA && hasSepaAlias)
      || userTypology === listUserTypology.OFFLINE
      || (userTypology === listUserTypology.INIT_TRANSFERT_DEFERRED && !params.idBasketOrder)"
      color="primary"
      [label]="'Ajouter à ma facturation'"
      (clickEvent)="handleClick({first: true})"
      data-id-cypress="add-to-facturation"
      class="mr-3"
    ></jhi-bary-button>

    <jhi-bary-button (clickEvent)="handleClick({second: true})" [outline]="true" [disabled]="clicked" [label]="'Annuler'" color="primary"></jhi-bary-button>
  </div>
</div>
